// WHAT THE FREE-ENTRY BANNER MAY STILL OFFER, as plain questions.
//
// Split out of App.jsx on 21 Sep 2026 so the deploy gate can test it:
// App.jsx is JSX, which node's test runner cannot import.
//
// Reported 21 Sep 2026, with both free routes switched on: "the banner
// only offered me the pixel, I clicked the button to use it, then
// cancelled it and I couldn't use the free pixel option at all."
//
// Two faults, one cause. "Use free entry" claims the guess credit
// FIRST, then enters pixel mode. From that moment freeEntryGuessUsed is
// true (it means CLAIMED), so:
//
//   - the pixel-mode sentence stopped mentioning the guess, although
//     the credit was sitting in the account waiting to be spent; and
//   - Cancel dropped the banner into its "taken" branch, which only
//     ever had words in it — "You still have a free pixel" and no way
//     to use it.
//
// Both questions below are asked of what is LEFT, not of what has been
// claimed.

// The free pixel is on for this competition and this buyer has not
// taken it.
export function canStillUseFreePixel(config) {
  return !!(config?.freeEntryPixelAvailable && !config?.freeEntryPixelUsed);
}

// The free guess is on and this buyer can still make it: either the
// credit has not been claimed yet, or it has been claimed and is still
// in the account.
export function freeGuessStillToCome(config) {
  return !!(
    config?.freeEntryGuessAvailable &&
    (!config?.freeEntryGuessUsed || (config?.freeEntryCreditsRemaining || 0) > 0)
  );
}
